import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/app-component/app.component.ts